<template>
  <div class="section-category section-full">
    <div class="col-xl-5 mx-auto py-xl-2">
      <h3 class="section-title-centered text-uppercase" v-translate>Choose Time</h3>
      <div class="row">
        <div class="form-group col-sm-6">
          <label for="timeStart" v-translate>Start time</label>
          <datetime
            type="date"
            input-class="form-control"
            format="dd/MM/yyyy"
            v-model="startTime"
          />
        </div>
        <div class="form-group col-sm-6">
          <label for="timeEnd" v-translate>End time</label>
          <datetime
            type="date"
            input-class="form-control"
            format="dd/MM/yyyy"
            v-model="endTime"
          />
        </div>
      </div>

      <div class="button-footer text-center pt-4">
        <button class="btn btn-primary px-4" @click="onConfirm" v-translate>Submit</button>
      </div>
    </div>
    <MonthReport ref="monthReport"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DayService from '@/services/DayService';
import ShiftService from '@/services/ShiftService';
import MonthReport from '@/components/MonthReport';
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';

export default {
  name: 'EndOfMonth',
  components: {
    MonthReport,
  },
  data() {
    return {
      startTime: null,
      endTime: null,
    };
  },
  computed: {
  },
  methods: {
    async onConfirm() {
      try {
        await this.$refs.monthReport.getMonthReport(
          this.$store.getters.getDatetime(this.startTime),
          this.$store.getters.getDatetime(this.endTime),
        );
      } catch (error) {
        this.$store.commit(SET_MESSAGE_MODAL, error.message || String(error));
      }
    }
  },
  async created() {
  },
};
</script>

<style scoped>
tr.border-top.border-bottom td {
  color: #F00;
}
</style>
